import { Grid } from '@material-ui/core';
import {
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
} from '@material-ui/core/styles';
import { convertToRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import MUIRichTextEditor from 'mui-rte';
import React from 'react';
import palette from 'theme/palette';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface TextEditorProps {
  title: string;
  initialValue?: any | string;
  error?: boolean;
  readOnly?: boolean;
  maxLength?: number;
  getValue?: (value: string) => void;
}

const TextEditor = ({
  title,
  initialValue,
  error,
  readOnly,
  maxLength,
  getValue,
}: TextEditorProps) => {
  const defaultTheme = createMuiTheme();
  const classes = useStyles();
  const [inital, setInital] = React.useState<any>();

  const handleGetValue = value => {
    if (getValue) {
      getValue(value);
    }
  };

  React.useEffect(() => {
    try {
      const isHtml = JSON.parse(initialValue);
      if (!isHtml.blocks) {
        setInital(JSON.stringify(convertToRaw(stateFromHTML(initialValue))));
      } else {
        setInital(initialValue);
      }
    } catch (error) {
      setInital(JSON.stringify(convertToRaw(stateFromHTML(initialValue))));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  Object.assign(defaultTheme, {
    overrides: {
      MUIRichTextEditor: {
        root: {
          marginTop: 20,
          minHeight: 100,
          height: 'auto',
          width: '100%',
          borderRadius: '4px',
          paddingLeft: '10px',
          border: `1px solid ${error ? palette.red : palette.lightGray}`,
          background: `${palette.superLightGray}`,
        },
        placeHolder: {
          marginLeft: '10px',
          height: '100px',
        },
      },
    },
  });

  return (
    <Grid
      container
      className={classes.container}
      data-testid={'autosky-texteditor'}
    >
      <MuiThemeProvider theme={defaultTheme}>
        <MUIRichTextEditor
          defaultValue={inital}
          toolbarButtonSize="small"
          controls={['bold', 'italic', 'underline']}
          onChange={value => {
            handleGetValue(stateToHTML(value.getCurrentContent()));
          }}
          label={title}
          readOnly={readOnly}
          maxLength={maxLength}
        />
      </MuiThemeProvider>
    </Grid>
  );
};

export default TextEditor;
